(() => {
  const domNodeMap = new Map();

  window.swinger = {
    ...window.swinger,
    domNodeMapper: {
      register(node) {
        const id = Math.round(Math.random() * 100000000);

        domNodeMap.set(id, node);
        return id;
      },
      get(id) {
        return domNodeMap.get(id);
      },
    },
  };
})();
